function IconButton({
  icon,
  iconComponent,
  className,
  onClick,
  text,
  iconEnd
}){
  return(
    <button 
      className={`${text ? "h-10 max-w-max px-4" :"h-10 w-10"} space-x-2 focus:outline-none bg-white rounded-full flex items-center justify-center ${className}`}
      onClick={onClick}>
      {icon && <img src={icon} className="object-cover focus:outline-none"/>}
      {iconComponent}
      {text && <p className="focus:outline-none">{text}</p>}
      {iconEnd && <img src={iconEnd} className="focus:outline-none object-cover"/>}
    </button>
  )
}

export default IconButton;